var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "closeCurrntPage", on: { click: _vm.closeCurrntPage } },
        [_vm._v("X关闭当前页")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "head" },
        [
          _c("span", [_vm._v("是否已生成采购订单")]),
          _vm._v(" "),
          _c(
            "el-select",
            {
              attrs: { size: "mini", placeholder: "请选择", clearable: "" },
              on: { change: _vm.checkboxHandler },
              model: {
                value: _vm.checkboxGroup,
                callback: function($$v) {
                  _vm.checkboxGroup = $$v
                },
                expression: "checkboxGroup"
              }
            },
            [
              _c("el-option", { attrs: { label: "是", value: 1 } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "否", value: 0 } })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          attrs: {
            data: _vm.tableData,
            "show-summary": "",
            "summary-method": _vm.getSummaries,
            border: ""
          },
          on: { "selection-change": _vm.selectOrder }
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", width: "55", fixed: "left" }
          }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { type: "index", label: "序号" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "created_at", label: "推送日期", width: "70px" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "main_number", label: "主订单号", width: "130px" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "serial_number", label: "编号" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.serial_number
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.serial_number
                                .split("-")
                                .slice(3)
                                .join("-")
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.express && _vm.isZhifaOrFactory
                      ? _c("span", [
                          _vm._v("(" + _vm._s(scope.row.express) + ")")
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "order_number", label: "子订单号", width: "130px" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "ruigu_code", label: "商品编码", width: "80px" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "self_code", label: "三方商品编码" }
          }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { prop: "name", label: "商品名称" } }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { prop: "spec", label: "规格" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "unit", label: "单位", width: "50px" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "订购金额", prop: "order_price", width: "60px" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "price", label: "单价", width: "60px" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "amount", label: "订购数量", width: "60px" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "send_amount", label: "实发数量", width: "60px" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "select-total-wrap" }, [
        _c("div", [_vm._v("选中合计")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("主订单数量: "),
          _c("span", [_vm._v(_vm._s(_vm.selectTotal.mainTotal))])
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v("子订单数量: "),
          _c("span", [_vm._v(_vm._s(_vm.selectTotal.orderTotal))])
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v("订购金额: "),
          _c("span", [_vm._v(_vm._s(_vm.selectTotal.priceTotal))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "time-wrap" }, [
        _c("div", [_vm._v("签订时间:" + _vm._s(_vm.nowTime))]),
        _vm._v(" "),
        _c(
          "div",
          [
            _vm._v("预计交货:\n      "),
            _c("el-date-picker", {
              attrs: {
                size: "mini",
                format: "yyyy-MM-dd",
                "value-format": "yyyy-MM-dd",
                type: "date",
                placeholder: "选择日期时间"
              },
              model: {
                value: _vm.checkTime,
                callback: function($$v) {
                  _vm.checkTime = $$v
                },
                expression: "checkTime"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "center" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.setOrder }
            },
            [_vm._v("生成采购订单")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "print-purchase" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "table",
          {
            staticStyle: { "border-bottom": "none" },
            attrs: {
              border: "1",
              width: "100%",
              align: "center",
              "border-collapse": "collapse"
            }
          },
          [
            _c("tr", [
              _c(
                "td",
                {
                  staticClass: "inner-table-td",
                  attrs: { colspan: _vm.colspan }
                },
                [
                  _c("div", { staticClass: "inner-table" }, [
                    _c(
                      "table",
                      {
                        attrs: { width: "100%", "border-collapse": "collapse" }
                      },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c("td", [
                              _c("span", [
                                _vm._v("签订时间：" + _vm._s(_vm.nowTime))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("span", [
                                _vm._v("预计交货：" + _vm._s(_vm.checkTime))
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("td", [
                              _c("span", [
                                _vm._v(
                                  " 供货方：" +
                                    _vm._s(_vm.printPurchaseData.CompanyName)
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _vm._m(2),
                            _vm._v(" "),
                            _c("td", [
                              _c("span", [
                                _vm._v(
                                  " 供方代理人：" +
                                    _vm._s(
                                      _vm.printPurchaseData
                                        .CompanyRepresentative
                                    )
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _vm._m(3),
                            _vm._v(" "),
                            _c("td", [
                              _c("span", [
                                _vm._v(
                                  " 供方电话：" +
                                    _vm._s(
                                      _vm.printPurchaseData
                                        .CompanyRepresentativeMobile
                                    )
                                )
                              ])
                            ])
                          ])
                        ])
                      ]
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _c(
              "tbody",
              { staticStyle: { "text-align": "center" } },
              [
                _vm._m(5),
                _vm._v(" "),
                _vm._l(_vm.selectOrderData, function(item, index) {
                  return _c("tr", { key: item.id }, [
                    _c("td", [_c("span", [_vm._v(_vm._s(index + 1))])]),
                    _vm._v(" "),
                    _c("td", [_c("span", [_vm._v(_vm._s(item.main_number))])]),
                    _vm._v(" "),
                    _c("td", [_c("span", [_vm._v(_vm._s(item.order_number))])]),
                    _vm._v(" "),
                    _c("td", [_c("span", [_vm._v(_vm._s(item.ruigu_code))])]),
                    _vm._v(" "),
                    _c("td", [_c("span", [_vm._v(_vm._s(item.self_code))])]),
                    _vm._v(" "),
                    _c("td", [_c("span", [_vm._v(_vm._s(item.name))])]),
                    _vm._v(" "),
                    _c("td", [_c("span", [_vm._v(_vm._s(item.spec))])]),
                    _vm._v(" "),
                    _c("td", [_c("span", [_vm._v(_vm._s(item.unit))])]),
                    _vm._v(" "),
                    _c("td", [_c("span", [_vm._v(_vm._s(item.order_price))])]),
                    _vm._v(" "),
                    _c("td", [_c("span", [_vm._v(_vm._s(item.price))])]),
                    _vm._v(" "),
                    _c("td", [_c("span", [_vm._v(_vm._s(item.amount))])]),
                    _vm._v(" "),
                    _c("td", [_c("span", [_vm._v(_vm._s(item.send_amount))])])
                  ])
                }),
                _vm._v(" "),
                _c("tr", [
                  _vm._m(6),
                  _vm._v(" "),
                  _c("td", [
                    _c("span", [_vm._v(_vm._s(_vm.printTableDataTotal))])
                  ]),
                  _vm._v(" "),
                  _c("td"),
                  _vm._v(" "),
                  _c("td", [
                    _c("span", [_vm._v(_vm._s(_vm.printTableNumTotal))])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("span", [_vm._v(_vm._s(_vm.printTableSendTotal))])
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c(
                    "td",
                    {
                      staticClass: "inner-table-td footer-table",
                      staticStyle: { "border-bottom": "1px solid #999" },
                      attrs: { colspan: _vm.colspan }
                    },
                    [_vm._m(7)]
                  )
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c(
                    "td",
                    {
                      staticStyle: {
                        "text-align": "left",
                        padding: "5px 0",
                        border: "0"
                      },
                      attrs: { colspan: _vm.colspan }
                    },
                    [
                      _vm._v(
                        "注：本单为采购意向单，商品采购以供货方最终实际供货情况为准。"
                      )
                    ]
                  )
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "tfoot",
              {
                staticStyle: {
                  display: "table-footer-group",
                  "font-weight": "bold"
                }
              },
              [
                _c("tr", [
                  _c(
                    "td",
                    {
                      staticClass: "footer",
                      attrs: { colspan: _vm.colspan, align: "center" }
                    },
                    [
                      _c("img", {
                        staticClass: "zhang",
                        attrs: {
                          src: require("./../../assets/img/zhang.png"),
                          alt: "",
                          width: "160px"
                        }
                      })
                    ]
                  )
                ])
              ]
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "text-align": "center" } }, [
      _c("h4", [_vm._v("采购订单")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("span", [_vm._v(" 平台方：上海鑫谊麟禾科技有限公司")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("span", [_vm._v(" 平台代理人：")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("span", [_vm._v(" 联系电话：021-31762063")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "thead",
      { staticStyle: { display: "table-header-group", "font-weight": "bold" } },
      [_c("tr")]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_c("span", [_vm._v("序号")])]),
      _vm._v(" "),
      _c("th", [_c("span", [_vm._v("主订单号")])]),
      _vm._v(" "),
      _c("th", [_c("span", [_vm._v("子订单号")])]),
      _vm._v(" "),
      _c("th", [_c("span", [_vm._v("商品编码")])]),
      _vm._v(" "),
      _c("th", [_c("span", [_vm._v("三方商品编码")])]),
      _vm._v(" "),
      _c("th", [_c("span", [_vm._v("商品名称")])]),
      _vm._v(" "),
      _c("th", [_c("span", [_vm._v("规格")])]),
      _vm._v(" "),
      _c("th", [_c("span", [_vm._v("单位")])]),
      _vm._v(" "),
      _c("th", [_c("span", [_vm._v("订购金额")])]),
      _vm._v(" "),
      _c("th", [_c("span", [_vm._v("单价")])]),
      _vm._v(" "),
      _c("th", [_c("span", [_vm._v("订购数量")])]),
      _vm._v(" "),
      _c("th", [_c("span", [_vm._v("实发数量")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      { staticStyle: { "text-align": "left" }, attrs: { colspan: "8" } },
      [_c("span", { staticStyle: { "font-weight": "600" } }, [_vm._v("合计")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inner-table" }, [
      _c(
        "table",
        {
          attrs: {
            height: "200px",
            width: "100%",
            "border-collapse": "collapse"
          }
        },
        [
          _c("tr", [
            _c("td", { staticStyle: { width: "100px" } }, [
              _c("span", [
                _vm._v(
                  "\n                      平台方评审：\n                    "
                )
              ])
            ]),
            _vm._v(" "),
            _c("td", [_c("span")]),
            _vm._v(" "),
            _c("td", { staticStyle: { width: "100px" } }, [
              _c("span", [_vm._v("供货单位：")])
            ]),
            _vm._v(" "),
            _c("td", [_c("span")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", { staticStyle: { width: "100px" } }, [
              _c("span", [_vm._v("经办人：")])
            ]),
            _vm._v(" "),
            _c("td", [_c("span")]),
            _vm._v(" "),
            _c("td", { staticStyle: { width: "100px" } }, [
              _c("span", [_vm._v("经办人：")])
            ]),
            _vm._v(" "),
            _c("td", [_c("span")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", { staticStyle: { width: "100px" } }, [
              _c("span", [_vm._v("负责人：")])
            ]),
            _vm._v(" "),
            _c("td", [_c("span")]),
            _vm._v(" "),
            _c("td", { staticStyle: { width: "100px" } }, [
              _c("span", [_vm._v("单位盖章：")])
            ]),
            _vm._v(" "),
            _c("td", [_c("span")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", { staticStyle: { width: "100px" } }, [_c("span")]),
            _vm._v(" "),
            _c("td", [_c("span")]),
            _vm._v(" "),
            _c("td", { staticStyle: { width: "100px" } }, [
              _c("span", [_vm._v("签订日期：")])
            ]),
            _vm._v(" "),
            _c("td", [_c("span")])
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59542e95", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59542e95","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bigorder/prinPurchase.vue
// module id = null
// module chunks = 